(function () {
  'use strict';

  function initializeCarousel(section) {
    if (!section || section.getAttribute('data-carousel-ready') === 'true') {
      return;
    }

    var track = section.querySelector('.mi-reviews-carousel__track');
    var slides = section.querySelectorAll('.mi-review-card');
    var previousButton = section.querySelector(
      '.mi-reviews-carousel__button--prev'
    );
    var nextButton = section.querySelector(
      '.mi-reviews-carousel__button--next'
    );
    var currentElement = section.querySelector(
      '.mi-reviews-carousel__current'
    );
    var totalElement = section.querySelector(
      '.mi-reviews-carousel__total'
    );

    if (
      !track ||
      !slides.length ||
      !previousButton ||
      !nextButton ||
      !currentElement ||
      !totalElement
    ) {
      return;
    }

    section.setAttribute('data-carousel-ready', 'true');

    function getVisibleCount() {
      if (window.innerWidth <= 749) {
        return 1;
      }

      if (window.innerWidth <= 989) {
        return 2;
      }

      return 3;
    }

    function getPageCount() {
      return Math.max(
        1,
        Math.ceil(slides.length / getVisibleCount())
      );
    }

    function getCardStep() {
      var firstSlide = slides[0];

      if (!firstSlide) {
        return track.clientWidth;
      }

      var styles = window.getComputedStyle(track);
      var gap =
        parseFloat(styles.columnGap) ||
        parseFloat(styles.gap) ||
        0;

      return firstSlide.getBoundingClientRect().width + gap;
    }

    function getCurrentPage() {
      var visibleCount = getVisibleCount();
      var cardStep = getCardStep();

      if (!cardStep) {
        return 1;
      }

      var firstVisibleCard = Math.round(
        track.scrollLeft / cardStep
      );

      return Math.min(
        getPageCount(),
        Math.floor(firstVisibleCard / visibleCount) + 1
      );
    }

    function updateControls() {
      var currentPage = getCurrentPage();
      var pageCount = getPageCount();
      var maximumScroll =
        track.scrollWidth - track.clientWidth;

      currentElement.textContent = String(currentPage);
      totalElement.textContent = String(pageCount);

      previousButton.disabled = track.scrollLeft <= 5;
      nextButton.disabled =
        track.scrollLeft >= maximumScroll - 5;
    }

    function moveCarousel(direction) {
      var distance =
        getCardStep() * getVisibleCount();

      track.scrollBy({
        left: direction * distance,
        behavior: 'smooth'
      });
    }

    previousButton.addEventListener('click', function () {
      moveCarousel(-1);
    });

    nextButton.addEventListener('click', function () {
      moveCarousel(1);
    });

    track.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        moveCarousel(-1);
      }

      if (event.key === 'ArrowRight') {
        event.preventDefault();
        moveCarousel(1);
      }
    });

    var scrollTimer;

    track.addEventListener(
      'scroll',
      function () {
        window.clearTimeout(scrollTimer);

        scrollTimer = window.setTimeout(
          updateControls,
          80
        );
      },
      false
    );

    window.addEventListener('resize', function () {
      updateControls();
    });

    updateControls();
  }

  function initializeAllCarousels(container) {
    var scope = container || document;
    var carousels = scope.querySelectorAll(
      '.mi-reviews-carousel'
    );

    for (var i = 0; i < carousels.length; i += 1) {
      initializeCarousel(carousels[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        initializeAllCarousels(document);
      }
    );
  } else {
    initializeAllCarousels(document);
  }

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      initializeAllCarousels(event.target);
    }
  );
})();